import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../hooks/axiosInstance";
import useAuth from "../../hooks/useAuthContext";

export default function Header({ setIsSidebarOpen, isSidebarOpen }) {
  const { userData, resetUser } = useAuth();
  const navigate = useNavigate();

   let fullname,
     position = "";
   if (userData && userData.userInfo) {
     fullname = userData.userInfo.user
       ? userData.userInfo.user.first_name
       : userData.userInfo.user.last_name +
         " " +
         userData.userInfo.user.first_name;

     position = userData?.userInfo?.user?.user_type?.user_type_name;
   }

  const logout = () => {
    const url = userData.userInfo.user
      ? "/user/auth/logout"
      : "/user/auth/logout";
    const loginPath = userData.userInfo.user ? "/auth/login" : "/auth/login";

    axiosInstance
      .post(url)
      .then((res) => {
        localStorage.removeItem("userData");
        localStorage.removeItem("userPermissions");
        resetUser();
        navigate(loginPath);
      })
      .catch((err) => {
        if (err.response.status == "401") {
          localStorage.removeItem("userData");
          localStorage.removeItem("userPermissions");
          navigate(loginPath);
        }
      });
  };

  const sideBarToggle = () => {
    setIsSidebarOpen((prevState) => !prevState); 
  };
  return (
    <>
      <header id="page-topbar" className={`${isSidebarOpen ? "" : "expand"}`}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/app/dashboard" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src="/assets/images/logo-sm.png" alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="/assets/images/logo-dark.png"
                      alt=""
                      height="17"
                    />
                  </span>
                </Link>

                <Link to="/app/dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img src="/assets/images/logo-sm.png" alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="/assets/images/logo-light.png"
                      alt=""
                      height="17"
                    />
                  </span>
                </Link>
              </div>

              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                // id="topnav-hamburger-icon"
                onClick={sideBarToggle}
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>

              {/* <!-- App Search--> */}
              <form className="app-search d-none d-md-block">
                <div className="position-relative">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    autocomplete="off"
                    id="search-options"
                    value=""
                  />
                  <span className="mdi mdi-magnify search-widget-icon"></span>
                  <span
                    className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                    id="search-close-options"
                  ></span>
                </div>
              </form>
            </div>

            <div className="d-flex align-items-center">
              <div className="dropdown ms-sm-3 header-item topbar-user">
                <button
                  type="button"
                  className="btn"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src="/assets/images/users/avatar-1.jpg"
                      alt="Header Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {fullname}
                      </span>
                      <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                        {position}
                      </span>
                    </span>
                  </span>
                </button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Welcome {fullname}!</h6>
                  <Link
                    className="dropdown-item cursor-pointer"
                    onClick={logout}
                  >
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
